import React, { useEffect, memo, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { mySoftKeys } from '../constants/storageKeys';
import { CONTEXT } from '../config';
import { logging } from '../actions/log';
import { changeClass, hasClass } from '../utils/utils';
import { setInTimeInstalledSoft } from '../actions/layout';
import { PCStoreJsBridge } from '../nativeapi';
import { getLocalSoft } from '../actions/native';

import styles from './InstDonePop.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInTimeInstSoft = createSelector(
  state => state.layout,
  layout => layout.inTimeInstSoft,
);

export default memo(() => {
  const dispatch = useDispatch();
  const inTimeInstSoft = useSelector(selectInTimeInstSoft);
  const logInfoData = useSelector(selectLogInfo);

  const instDonePopEL = useRef(null);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Installation',
        label: '',
        param2: {
          source: 'Installation',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  useEffect(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'I',
          action: 'Installation',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
    }
  }, [dispatch, inTimeInstSoft]);

  useEffect(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      runPop(inTimeInstSoft, instDonePopEL);
    } else if (instDonePopEL && instDonePopEL.current) {
      changeClass(instDonePopEL.current, styles.instDonePop_fadeIn, styles.instDonePop_fadeOut);
    }
  }, [dispatch, inTimeInstSoft]);

  const runPop = useCallback(
    (inTimeInstSoftData, instDonePopELData) => {
      setTimeout(() => {
        if (+new Date() - window.inTimeInstSoftTime > 15 * 1000) {
          if (inTimeInstSoft && inTimeInstSoft.appInfo && instDonePopEL && instDonePopEL.current) {
            changeClass(
              instDonePopEL.current,
              styles.instDonePop_fadeOut,
              styles.instDonePop_fadeIn,
            );
          }
        } else {
          runPop(inTimeInstSoftData, instDonePopELData);
        }
      }, 1000);
    },
    [inTimeInstSoft, instDonePopEL],
  );

  const onAnimationEndFadeOut = useCallback(() => {
    if (
      inTimeInstSoft &&
      inTimeInstSoft.appInfo &&
      instDonePopEL &&
      instDonePopEL.current &&
      hasClass(instDonePopEL.current, styles.instDonePop_fadeOut)
    ) {
      dispatch(setInTimeInstalledSoft(null));
    }
  }, [dispatch, instDonePopEL, inTimeInstSoft]);

  const handleLink = useCallback(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'C',
          action: 'Installation',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
      onColsePop();
    }
  }, [dispatch, logInfoData, inTimeInstSoft]);

  const onColsePop = useCallback(() => {
    if (inTimeInstSoft && inTimeInstSoft.appInfo) {
      dispatch(
        logging({
          category: 'C',
          action: 'Installation_Close',
          label: '',
          param2: {
            source: 'Installation',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softType: '1',
            softid: inTimeInstSoft.appInfo.packageName,
            softName: inTimeInstSoft.appInfo.softName,
            packageName: inTimeInstSoft.appInfo.packageName,
            versionCode: inTimeInstSoft.appInfo.versionCode,
          },
        }),
      );
      changeClass(instDonePopEL.current, styles.instDonePop_fadeOut, styles.instDonePop_fadeIn);
      dispatch(setInTimeInstalledSoft(null));
    }
  }, [dispatch, logInfoData, instDonePopEL]);

  // 打开软件
  const onOpenSoft = useCallback(() => {
    const logParam2 = {
      source: 'Installation',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
    };
    logParam2.softType = '1';
    logParam2.softid = inTimeInstSoft.appInfo.packageName;
    logParam2.versionCode = inTimeInstSoft.appInfo.versionCode;
    logParam2.softName = inTimeInstSoft.appInfo.softName;
    // 首先判断模拟器是否已经安装。
    PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
      if (SIMInstalled) {
        PCStoreJsBridge.openAndroidSoft({ ...inTimeInstSoft.appInfo, logInfo: logParam2 }).then(
          isOpen => {
            if (isOpen !== true) {
              // message.info('软件运行失败！');
            }
          },
        );
      }
    });

    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
    const spotSoft = spotSoftStr && spotSoftStr.split(',');
    if (spotSoft && spotSoft.indexOf(inTimeInstSoft.appInfo.packageName) > -1) {
      spotSoft.splice(spotSoft.indexOf(inTimeInstSoft.appInfo.packageName), 1);
      localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSoft.join(','));
    }
    dispatch(getLocalSoft());
  }, [dispatch, logInfoData, inTimeInstSoft]);

  return (
    inTimeInstSoft &&
    inTimeInstSoft.appInfo && (
      <div
        className={styles.instDonePop_fadeIn}
        ref={instDonePopEL}
        onAnimationEnd={() => onAnimationEndFadeOut()}
      >
        <div className={styles.instDonePop_icon}>
          <Link
            to={{ pathname: `${CONTEXT}/uninstall` }}
            onClick={() => {
              handleLink();
            }}
          >
            <img
              className={styles.instDonePop_icon_img}
              src={inTimeInstSoft.appInfo.logoFile}
              alt="img"
            />
          </Link>
          <div className={styles.instDonePop_icon_alogo} />
        </div>
        <Link
          className={styles.instDonePop_info}
          to={{ pathname: `${CONTEXT}/uninstall` }}
          onClick={() => {
            handleLink();
          }}
        >
          <span className={styles.instDonePop_info_soft}>{inTimeInstSoft.appInfo.softName}</span>
          <span className={styles.instDonePop_info_phone}>手机版</span>
          <span className={styles.instDonePop_info_desc}>安装完成</span>
        </Link>
        <div className={styles.instaDonePop_open} onClick={onOpenSoft}>
          打开
        </div>
        <div className={styles.instDonePop_close} onClick={() => onColsePop()} />
      </div>
    )
  );
});
